import React from 'react';
import styles from './index.css';
class NormalCaption extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            menuShow: false,
        };
        this.handleClick = () => {
            const { menuShow } = this.state;
            this.setState({
                menuShow: !menuShow,
            });
        };
    }
    render() {
        const { menuShow } = this.state;
        const { title, content } = this.props;
        return (React.createElement("div", { className: styles.caption },
            React.createElement("a", { className: styles.icon, href: "//i.ifeng.com" }),
            React.createElement("div", { className: styles.title }, title.map((item, index) => (React.createElement(React.Fragment, { key: index },
                React.createElement("a", { href: item.url }, item.title),
                index === title.length - 1 ? '' : React.createElement("span", null))))),
            React.createElement("div", { className: menuShow ? styles.down : styles.menu, onClick: this.handleClick }),
            menuShow ? (React.createElement("div", { className: styles.menu_box },
                React.createElement("ul", { className: styles.list }, content.map((item, index) => (React.createElement("li", { key: index },
                    React.createElement("a", { href: item.url }, item.title))))))) : ('')));
    }
}
export default NormalCaption;
